import { Collapse } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { doResetValuesAndEmptyTheReducers } from "../../base/utils";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { sidebarActions } from "../../store/slices/main_layout_slice/sidebar_slice";
import { CallPopUpAgentActions } from "../../store/slices/voice_call_slice/call_popup_agent";
import { ChatConfigurtationActions } from "../../store/slices/chat_configuration_slice/chat_configuration_slice";
import { ChatState } from "../../base/models/model";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { ROLES } from "../../base/constant";

function BasicMenu(props: any) {
  const dispatch = useDispatcher();
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const [queryString, setQueryString] = useState<any>("");
  const [navigateValues, setNavigateValues] = useState<any>("");
  const location = useLocation();
  const { loginUserDetails } = useSelector((state: any) => state.loginUser);
  const commonReducer: any = useSelector((state: any) => state.sideBar);
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  let admin =
    roleId && (roleId.split(",").includes(ROLES.ADMIN_ROLE_ID) || roleId.split(",").includes(ROLES.SUB_OWNER_ROLE_ID) || roleId.split(",").includes(ROLES.OWNER_ROLE_ID));
  let { servicePlan } = chatReducer;
  const [productid, setProductid] = useState<any>(GetItemFromStorage(LocalStorage.PRODUCT_ID));
  const loginPlanDetail = GetItemFromStorage(LocalStorage.PLAN_ID);
  useEffect(() => {
    const { pathname } = location;
    let splitLocation = pathname.split("/");
    setQueryString(splitLocation[1]);
  }, [navigateValues]);
  const doNavigate = (navigateValues: any, selectedValue: any) => {
    dispatch(sidebarActions.leftMenuValues({ mainValue: "" }));
    dispatch(sidebarActions.settingsMenu({ settingsMenuValue: selectedValue }));
    navigate(navigateValues);
    setNavigateValues(navigateValues);
    doResetValuesAndEmptyTheReducers();
  };
  // 
  return (
    <>
      <Collapse
        accordion
        defaultActiveKey={["1"]}
        expandIconPosition="end"
        className="menuAccordion"
        expandIcon={({ isActive }) => (isActive ? <span className="icon__DownarrowWhite16 active" /> : <span className="icon__DownarrowWhite16" />)}
      >
        <Panel header="Basic Configurations" key="1">
          <ul className="subMenuSmall">
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "cc" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/contactcenternumber", "cc");
              }}
            >
              Contact Centre Numbers
            </li>}
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "pp" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/playprompt", "pp");
              }}
            >
              Prompt Library
            </li>}
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "sm" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/skillmanagement", "sm");
              }}
            >
              Skill Management
            </li>}
            <li
              className={commonReducer.settingsMenuValue === "um" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/usermanagement", "um");
              }}
            >
              User Management
            </li>
            <li
              className={commonReducer.settingsMenuValue === "bh" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/businesshours/list", "bh");
              }}
            >
              Business Hours
            </li>
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "cq" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/customqueue/list", "cq");
              }}
            >
              Custom Queue
            </li>}
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "rp" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/routingprofile", "rp");
              }}
            >
              Routing Profile
            </li>}
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "cf" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/callFlow", "cf");
              }}
            >
              Call flow
            </li>}
            {/* <li
              className={commonReducer.settingsMenuValue === "chf" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/chatflowlist", "chf");
              }}
            >
              Chatflow
            </li> */}
          </ul>
        </Panel>
        <Panel header="General Settings" key="2">
          <ul className="subMenuSmall">
            <li
              className={commonReducer.settingsMenuValue === "as" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/agentstatus", "as");
              }}
            >
              Agent Status
            </li>
            <li
              className={commonReducer.settingsMenuValue === "ds" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/dispositionstatus", "ds");
              }}
            >
              Disposition Status
            </li>
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "ct" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/customertag", "ct");
              }}
            >
              Customer Tag
            </li>}
          </ul>
        </Panel>
        {admin && loginPlanDetail !== 54 && (
          <Panel header="Advance Settings" key="3">
            <ul className="subMenuSmall">
              <li
                className={commonReducer.settingsMenuValue === "cs" ? "active" : ""}
                onClick={() => { doNavigate("/connectors", "cs");
                }} >
                Connectors
              </li>
            </ul>
          </Panel>
        )}

        {/* <Panel header="Channel Configurations" key="3">
          <ul className="subMenuSmall">
            <li
              className={commonReducer.settingsMenuValue === "wl" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                dispatch(ChatConfigurtationActions.codeSnippet({ codeSnippet: '' }))
                doNavigate("/webchatwidget/list", "wl");
              }}
            >
              Web Chat
            </li>
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "sml" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                doNavigate("/smsListTable", "sml");
              }}
            >
              SMS Channel
            </li>}
            {productid !== "15" && <li
              className={commonReducer.settingsMenuValue === "el" ? "active" : ""}
              onClick={() => {
                dispatch(CallPopUpAgentActions.closeDialPadForAll());
                dispatch(ChatConfigurtationActions.codeSnippet({ codeSnippet: '' }))
                doNavigate("/emailconfig", "el");
              }}
            >
              Email channel
            </li>}
          </ul>
        </Panel> */}
        <ul className="Newlimenu">
          <li>
            <div className="subMenuSmall">
              <span onClick={() => {
                navigate("channelconfiguration");
              }}>Channel Configuration</span>
            </div>
          </li>
        </ul>


      </Collapse>
    </>
  );
}

export { BasicMenu };
